import { createReducer, on } from '@ngrx/store';
import { removeToastAction, showToastAction } from './toast.actions';
import { initialState, Toast, ToastState } from './toast.state';

/**
 * Called when we're going to show a toast
 */
const onShowToast = on(showToastAction, (state: ToastState, action) => {
	const newState = {
		...state,
		toasts: state.toasts.slice(0),
	};
	const { toastType, onClose, message } = action;
	const toast: Toast = {
		toastType,
		onClose,
		message,
	};
	newState.toasts.push(toast);
	return newState;
});

/**
 * Called when removing a toast
 */
const onRemoveToast = on(removeToastAction, (state: ToastState, action) => {
	const newState = {
		...state,
		toasts: state.toasts.slice(0),
	};
	if (newState?.toasts.length) {
		newState.toasts.shift();
	}
	return newState;
});

export const toastReducer = createReducer(initialState, onShowToast, onRemoveToast);
